"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getToken = getToken;
exports.updateTokens = updateTokens;
exports.clearTokens = clearTokens;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getToken(client) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'idToken';
  var state = client.getState();
  return state.tokens ? state.tokens[type] : null;
} // update tokens upon automatic token refresh


function updateTokens(client, tokens) {
  var replaceState = client.replaceState;
  var state = client.getState();
  var existingTokens = state.tokens;
  replaceState(_objectSpread({}, state, {
    tokens: _objectSpread({}, existingTokens, {}, tokens)
  }));
} // explicitly clear Tokens


function clearTokens(client) {
  var replaceState = client.replaceState;
  var state = client.getState();
  replaceState(_objectSpread({}, state, {
    tokens: undefined
  }));
}